import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75eb9961"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-8" }, "Bijlages", -1))
const _hoisted_4 = {
  key: 1,
  class: "no-mb"
}


import { CommentOutlined } from '@ant-design/icons-vue'
import MessageFilelist from '@/components/message/MessageFilelist.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageCommentsCard',
  props: {
    comments: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "Opmerkingen" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        class: "no-mb",
        gutter: [16,16]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              (__props.comments.length)
                ? (_openBlock(), _createBlock(_component_a_list, {
                    key: 0,
                    dataSource: __props.comments,
                    itemLayout: "horizontal"
                  }, {
                    renderItem: _withCtx(({ item }) => [
                      _createVNode(_component_a_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_list_item_meta, null, {
                            avatar: _withCtx(() => [
                              _createVNode(_component_a_avatar, {
                                shape: "square",
                                size: 48
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CommentOutlined))
                                ]),
                                _: 1
                              })
                            ]),
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.user.full_name) + " ", 1),
                              _createElementVNode("span", _hoisted_1, [
                                _createVNode(_component_a_tooltip, {
                                  title: new Date(item.created_at).toLocaleString('nl-NL'),
                                  placement: "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.ago), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["title"])
                              ])
                            ]),
                            description: _withCtx(() => [
                              _createVNode(_component_a_row, {
                                gutter: [16,16],
                                class: "no-mb"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "comment",
                                        innerHTML: item.body
                                      }, null, 8, _hoisted_2)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.media.length)
                                    ? (_openBlock(), _createBlock(_component_a_col, {
                                        key: 0,
                                        span: 24
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_3,
                                          _createVNode(MessageFilelist, {
                                            media: item.media
                                          }, null, 8, ["media"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["dataSource"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_4, "Er zijn nog geen opmerkingen geplaatst."))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})